import { colorTokens } from './tokens/colors';
import { typographyTokens } from './tokens/typography';
import { spacingTokens } from './tokens/spacing';
import { borderTokens } from './tokens/borders';
import { shadowTokens } from './tokens/shadows';

export const defaultGlobalTokens: Record<string, string> = {
  ...colorTokens,
  ...typographyTokens,
  ...spacingTokens,
  ...borderTokens,
  ...shadowTokens,
};
